import { render, staticRenderFns } from "./PaymentTable.vue?vue&type=template&id=38bd5258&scoped=true"
import script from "./PaymentTable.vue?vue&type=script&lang=js"
export * from "./PaymentTable.vue?vue&type=script&lang=js"
import style0 from "./PaymentTable.vue?vue&type=style&index=0&id=38bd5258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bd5258",
  null
  
)

export default component.exports